import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
	heading: {
		fontSize: theme.typography.pxToRem(15)
	}
}));

export default useStyles;
